var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBoxSelectedWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10c0-2.652-1.054-5.196-2.929-7.071C15.196 1.054 12.652 0 10 0zm4.35 7.73l-5.62 5.62c-.09.097-.217.152-.35.152-.133 0-.26-.055-.35-.152L5.65 11c-.095-.094-.148-.222-.148-.355 0-.133.053-.261.148-.355l.53-.53c.09-.097.217-.152.35-.152.133 0 .26.055.35.152l1.5 1.49 4.74-4.74c.194-.19.506-.19.7 0l.53.53c.184.193.184.497 0 .69z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxSelectedWhite);
export default __webpack_public_path__ + "static/media/checkBoxSelectedWhite.12d9f0a60ac03ba41446719b6f8d25f4.svg";
export { ForwardRef as ReactComponent };